import * as React from 'react';
import '../css/content-card.sass';
import Card from './Card';
import Anchor from './Anchor';

interface ContentCardProps {
  id: string;
  title: string;
  description: string;
  linkUrl?: string;
  linkLabel?: string;
  disableLink?: boolean;
  forwardLink?: boolean;
  theme?: 'night' | 'day';
  logoUrl?: string;
  headingLevel?: 'h1' | 'h2' | 'h3';
}

export default function ContentCard(props: ContentCardProps) {
  const {
    theme = 'day',
    disableLink = false,
    forwardLink = true,
    headingLevel = 'h2'
  } = props;
  const CustomHeading = React.createElement(
    headingLevel,
    { },
    props.title
  );
  return (
    <div className={`content-card ${theme}`}>
      <Card theme={theme}>
        {props.logoUrl && (
          <img
            className="content-card-logo"
            src={props.logoUrl}
            alt={props.logoUrl}
          />
        )}
        <div className="contents">
          {CustomHeading}
          <p className="description">{props.description}</p>
        </div>
        {props.linkUrl && props.linkLabel && (
          <div className="link">
            <Anchor
              arialabel={`link ${props.id}`}
              id={`link ${props.id}`}
              href={props.linkUrl}
              theme={theme}
              disabled={disableLink}
              forward={forwardLink}
            >
              {props.linkLabel}
            </Anchor>
          </div>
        )}
      </Card>
    </div>
  );
}
